import classNames from "classnames"
import React, { ReactNode } from "react"

import Typography from "@components/elements/V2/Typography"
import { Color } from "@constants/V2/color"
import {
  getBackgroundColorClass,
  getTransparentBorderColorClass,
} from "@utils/V2/color"

type BorderedIconButtonProps = {
  icon: ReactNode
  text?: string
  onClick: () => void
  className?: string
  disabled?: boolean
  backgroundColor?: Color
}

const BorderedIconButton = ({
  icon,
  text,
  onClick,
  className,
  disabled = false,
  backgroundColor,
}: BorderedIconButtonProps) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        "rounded-2xs group flex items-center justify-center border-[1.5px]",
        backgroundColor
          ? getBackgroundColorClass(backgroundColor)
          : "bg-transparent",
        getTransparentBorderColorClass(Color.Charcoal),
        className
      )}
    >
      {icon}
      {text && (
        <Typography
          text={text}
          font="grotesk"
          weight="medium"
          size="body-sm"
          color={Color.Black}
        />
      )}
    </button>
  )
}

export default BorderedIconButton
